import { createReducer, on } from '@ngrx/store';
import { v4 as uuidv4 } from 'uuid';
import { AccordionSearchActions } from './accordion-search.actions';
import { Section } from '../overview/model/overview.model';

export interface AccordionSearchState {
  loading: boolean;
  error: string;
  searchText: string;
  sections: Section[];
}

export const initialState: AccordionSearchState = {
  loading: false,
  error: '',
  searchText: '',
  sections: [],
};

export const accordionSearchReducer = createReducer(
  initialState,
  on(AccordionSearchActions.loadSections, state => ({
    ...state,
    loading: true,
  })),
  on(AccordionSearchActions.setSections, (state, { sections }) => ({
    ...state,
    sections: sections.map(section => ({
      ...section,
      id: section.id ?? uuidv4(),
    })),
    loading: false,
  })),
  on(AccordionSearchActions.collapseAll, state => ({
    ...state,
    sections: state.sections.map(section => ({
      ...section,
      collapsed: true,
    })),
  })),
  on(AccordionSearchActions.expandAll, state => ({
    ...state,
    sections: state.sections.map(section => ({
      ...section,
      collapsed: false,
    })),
  })),
  on(AccordionSearchActions.toggleSection, (state, { id }) => ({
    ...state,
    sections: state.sections.map(accordion =>
      accordion.id === id
        ? { ...accordion, collapsed: !accordion.collapsed }
        : accordion
    ),
  })),
  on(AccordionSearchActions.collapseAllFiltered, state => ({
    ...state,
    sections: state.sections.map(section => ({
      ...section,
      filterCollapsed: true,
    })),
  })),
  on(AccordionSearchActions.expandAllFiltered, state => ({
    ...state,
    sections: state.sections.map(section => ({
      ...section,
      filterCollapsed: false,
    })),
  })),
  on(AccordionSearchActions.toggleSectionFiltered, (state, { id }) => ({
    ...state,
    sections: state.sections.map(section =>
      section.id === id
        ? { ...section, filterCollapsed: !section.filterCollapsed }
        : section
    ),
  }))
);
